<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <form @submit.prevent="definePassword">
          <b-loading
            :is-full-page="true"
            :active="isLoading"
            :can-cancel="false"
          ></b-loading>

          <div class="columns">
            <div class="column"></div>
            <div class="column is-half has-text-centered">
              <img
                id="logo-navbar"
                src="../../assets/img/logo-smart-orange-outline.png"
                width="170"
                height="22"
                alt="Logo Onii"
                title="Onii"
              />

              <h1 class="title is-size-3 has-text-weight-semibold">
                Criar Senha
              </h1>

              <h2 class="subtitle">
                Escolha uma senha com, no mínimo, 6 caracteres
              </h2>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  placeholder="Senha"
                  password-reveal
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="passwordConfirmation"
                  class="is-expanded"
                  type="password"
                  placeholder="Confirmação de Senha"
                  password-reveal
                ></b-input>
              </b-field>

              <button
                class="button is-primary is-medium is-fullwidth has-text-weight-bold"
              >
                Definir Senha
              </button>
            </div>
            <div class="column"></div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      emailValidationToken: "",
      password: "",
      passwordConfirmation: ""
    };
  },

  methods: {
    definePassword() {
      this.isLoading = true;
      this.$store
        .dispatch("definePassword", {
          emailValidationToken: this.emailValidationToken,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "Você já pode fazer login com sua nova senha ;)",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.emailValidationToken = this.$route.query.emailValidationToken;
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
